import { typeUtils } from '@festina-life/core'

import type { AppSettings } from './fetchAppSettings'

const isEnvironmentSettings = (
  appSettings: unknown,
): appSettings is Record<
  'environments',
  Record<string, Record<string, string | boolean>>
> =>
  typeUtils.isObject(appSettings) &&
  typeUtils.isObject(appSettings['environments']) &&
  Object.values(appSettings['environments']).every(
    (environment) => typeof environment === 'object',
  )

export const sanitizeAppSettings = (appSettings: unknown): AppSettings => {
  if (isEnvironmentSettings(appSettings)) {
    const appSettingsCopy = structuredClone(appSettings)
    Object.values(appSettingsCopy.environments).forEach((environment) => {
      Object.entries(environment).forEach(([key, value]) => {
        if (typeof value === 'string') {
          const valueLowerCased = value.toLowerCase()

          if (valueLowerCased === 'true' || valueLowerCased === 'false') {
            environment[key] = valueLowerCased === 'true' ? true : false
          }
        }
      })
    })

    return appSettingsCopy as AppSettings
  } else {
    throw new Error('Invalid app settings provided.')
  }
}
